import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'vw-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabComponent {
  /**
   * Onglets : libellé (clé i18n) et ses paramètres. L'apparence est celle des
   * jetons Terreau ; `icon`, `tailwindClasses`, `height`, `width` et `border`
   * ne sont plus lus (gardés pour ne pas casser les appelants).
   */
  @Input() tabs: Array<{
    label: string,
    labelPayload?: any,
    icon?: string,
    tailwindClasses?: string,
    height?: string,
    width?: string,
    border?: string
  }> = [];
  /** Plus lu : la piste est la même sur fond crème ou blanc. */
  @Input() style: string = '';
  @Input() isLoading: boolean = false;

  @Input() activeTab: number | null = 0; // Keep track of the active tab (null : aucun)

  @Output() tabSelected = new EventEmitter<number>(); // Emit event on tab click

  selectTab(index: number) {
    this.activeTab = index;
    this.tabSelected.emit(index); // Emit event when tab is selected
  }
}
